class GiftWrapUpsell extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  connectedCallback() {
    if (GiftWrapUpsell.lastCart) {
      this.applyCart(GiftWrapUpsell.lastCart);
    } else {
      this.refresh();
    }
  }

  onClick(event) {
    const btn = event.target.closest('[data-gw-add]');
    if (!btn) return;
    event.preventDefault();
    this.addGiftWrap(btn);
  }

  async addGiftWrap(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';

    this.setState('note', true);

    try {
      const sections = (typeof sectionsToRender !== 'undefined' && sectionsToRender)
        ? sectionsToRender.map(s => s.section).join(',')
        : 'cart-drawer';

      const res = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname
        })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Add failed');

      GiftWrapUpsell.preserveOnNextRender = true;
      GiftWrapUpsell.preservedState = 'note';

      const cartDrawer = document.querySelector('cart-drawer');
      if (data.sections && cartDrawer?.renderContents) {
        cartDrawer.renderContents(data);
      }

      if (typeof updateFreeShipping === 'function') updateFreeShipping();
      if (typeof updateCartCounters === 'function') updateCartCounters();
    } catch (err) {
      console.error('[gift-wrap]', err);
      this.setState('card', false);
      btn.disabled = false;
      btn.textContent = originalText;
    }
  }

  setState(newState, flash) {
    const oldState = this.dataset.state;
    if (oldState === newState) return;
    this.dataset.state = newState;

    if (flash && newState === 'note') {
      const note = this.querySelector('[data-gw-note]');
      if (note) {
        note.classList.remove('is-fresh');
        void note.offsetWidth;
        note.classList.add('is-fresh');
        note.addEventListener('animationend', () => note.classList.remove('is-fresh'), { once: true });
      }
    }
  }

  applyCart(cart) {
    const productId = parseInt(this.dataset.productId, 10);
    let inCart = false, otherItems = false;
    for (const item of cart.items) {
      if (item.product_id === productId) inCart = true;
      else otherItems = true;
    }

    let newState = 'none';
    if (inCart) newState = 'note';
    else if (otherItems) newState = 'card';

    this.setState(newState, false);
  }

  async refresh() {
    try {
      const cartRes = await fetch(`${routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } });
      if (!cartRes.ok) return;
      const cart = await cartRes.json();
      GiftWrapUpsell.lastCart = cart;
      this.applyCart(cart);
    } catch (e) {}
  }
}

GiftWrapUpsell.lastCart = null;
GiftWrapUpsell.preserveOnNextRender = false;
GiftWrapUpsell.preservedState = null;

if (!customElements.get('gift-wrap-upsell')) {
  customElements.define('gift-wrap-upsell', GiftWrapUpsell);
}

(function () {
  function injectIfMissing() {
    const body = document.querySelector('#CartDrawer-Body');
    if (!body) return null;

    const bottom = body.querySelector('.cart-drawer__bottom');
    const summary = bottom?.querySelector('.cart-drawer__summary');
    const note = bottom?.querySelector('.cart-drawer__note');
    if (!bottom || !summary) return null;

    let existing = body.querySelector('gift-wrap-upsell');
    if (existing) {
      if (GiftWrapUpsell.preserveOnNextRender && GiftWrapUpsell.preservedState) {
        existing.dataset.state = GiftWrapUpsell.preservedState;
        GiftWrapUpsell.preserveOnNextRender = false;
        GiftWrapUpsell.preservedState = null;
      }
      return existing;
    }

    const template = document.getElementById('gift-wrap-upsell-template');
    if (!template) return null;

    const clone = template.content.cloneNode(true);
    const newEl = clone.querySelector('gift-wrap-upsell');

    let targetState = null;

    if (GiftWrapUpsell.preserveOnNextRender && GiftWrapUpsell.preservedState) {
      targetState = GiftWrapUpsell.preservedState;
      GiftWrapUpsell.preserveOnNextRender = false;
      GiftWrapUpsell.preservedState = null;
    } else if (newEl && GiftWrapUpsell.lastCart) {
      const productId = parseInt(newEl.dataset.productId, 10);
      let inCart = false, otherItems = false;
      for (const item of GiftWrapUpsell.lastCart.items) {
        if (item.product_id === productId) inCart = true;
        else otherItems = true;
      }
      if (inCart) targetState = 'note';
      else if (otherItems) targetState = 'card';
      else targetState = 'none';
    }

    if (newEl) {
      newEl.dataset.state = 'none';
    }

    bottom.insertBefore(clone, note || summary);

    const inserted = body.querySelector('gift-wrap-upsell');
    if (inserted && targetState) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          inserted.dataset.state = targetState;
        });
      });
    }

    return inserted;
  }

const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await origFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      if (/\/cart\/(add|change|update|clear)/.test(url) && response.ok) {
        const cloned = response.clone();
        cloned.json().then(data => {
          if (data && Array.isArray(data.items)) {
            GiftWrapUpsell.lastCart = data;
          }
          setTimeout(() => {
            const el = injectIfMissing();
            if (!el) return;
            if (data && Array.isArray(data.items)) {
              if (!GiftWrapUpsell.preserveOnNextRender) {
                const productId = parseInt(el.dataset.productId, 10);
                let inCart = false, otherItems = false;
                for (const item of data.items) {
                  if (item.product_id === productId) inCart = true;
                  else otherItems = true;
                }
                let targetState = 'none';
                if (inCart) targetState = 'note';
                else if (otherItems) targetState = 'card';

                if (el.dataset.state !== targetState) {
                  el.dataset.state = 'none';
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      el.dataset.state = targetState;
                    });
                  });
                }
              }
            } else if (typeof el.refresh === 'function') {
              el.refresh();
            }
          }, 50);
        }).catch(() => {});
      }
    } catch (e) {}
    return response;
  };

  document.addEventListener('DOMContentLoaded', () => {
    injectIfMissing();
  });
})();